import React from "react";
import * as echarts from "echarts";
import {
  CalendarOutlined,
  LoadingOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import {
  visitorsSparcalOption,
  visitsSparcalOption,
} from "../Data/DashbordData";
import moment from "moment";
import "moment/locale/th";
import { Button, Flex } from "antd";
import AppContext from "./AppContext";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import i18next from "i18next";

class PageHeader extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      toggleMenu: false,
      customDate: true,
      showCustomDate: false,
      time: new Date().toLocaleTimeString(),
    };
    this.visitorsChart = null;
    this.visitsChart = null;
  }

  // --- Lifecycle Methods ---
  componentDidMount() {
    this.initializeCharts();
    window.addEventListener("resize", this.handleResize);
    this.activeKey1();
    this.timerID = setInterval(() => this.tick(), 1000);
  }

  componentWillUnmount() {
    if (this.visitorsChart) {
      this.visitorsChart.dispose();
    }
    if (this.visitsChart) {
      this.visitsChart.dispose();
    }
    window.removeEventListener("resize", this.handleResize);
    clearInterval(this.timerID);
  }
  tick() {
    this.setState({ time: new Date().toLocaleTimeString(), });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.toggleMenu !== this.state.toggleMenu) this.resizeCharts();
  }

  // --- Chart Management ---

  initializeCharts = () => {
    const visitorsChartDom = document.getElementById("visitorsSparcalChart");
    if (visitorsChartDom) {
      this.visitorsChart = echarts.init(visitorsChartDom);
      this.visitorsChart.setOption(visitorsSparcalOption);
    }

    const visitsChartDom = document.getElementById("visitsSparcalChart");
    if (visitsChartDom) {
      this.visitsChart = echarts.init(visitsChartDom);
      this.visitsChart.setOption(visitsSparcalOption);
    }
  };

  resizeCharts = () => {
    if (this.visitorsChart) {
      this.visitorsChart.resize();
    }
    if (this.visitsChart) {
      this.visitsChart.resize();
    }
  };

  handleResize = () => this.resizeCharts();

  onToggleMenu = () => {
    this.setState(
      (prevState) => ({
        toggleMenu: !prevState.toggleMenu,
      }),
      () => {
        const { toggleMenu } = this.state;
        if (!toggleMenu) {
          document.body.classList.remove("layout-fullwidth");
        } else {
          document.body.classList.add("layout-fullwidth");
        }
        this.resizeCharts();
      },
    );
  };
  activeKey1() { this.setState({ showCustomDate: false }); }

  render() {
    const { HeaderText, Breadcrumb } = this.props;
    const currentLanguage = i18next.language;
    let tFormat = currentLanguage;
    let dFormat = tFormat === "lao" ? "lo" : tFormat;
    const effectiveBreadcrumb = Array.isArray(Breadcrumb) ? Breadcrumb : [];
    const { customDate, time } = this.state; //, toggleMenu
    const { isIcon, handleReload, activeKey1, reloading, isMobile } = this.context;

    return (
      <div className={activeKey1 === "dashboard"  ? "block-header mb--5": "block-header"}>
        <div className="row" style={{ flexWrap: isMobile ? "nowrap" : "wrap" }}>
          <div id="col-style" className="col-lg-5 col-md-6 col-sm-5 fs-sm-10">
            <h2 className="block-sm-header">
              <span
                className="btn btn-xs btn-link btn-toggle-fullwidth"
                style={{ cursor: "default" }}
              >
                {isIcon()}
              </span>
              {HeaderText}
            </h2>
            <ul className="breadcrumb text-truncate">
              <li className="breadcrumb-item">
                <Link to="/dashboard" style={{ marginLeft: "15px" }}>
                  {activeKey1 === "dashboard" ? null : (<i className="icon-home"></i>)}
                </Link>
              </li>
              {effectiveBreadcrumb.map((item, index) => (
                <li key={item.name + index} className="breadcrumb-item active">
                  <span className="disabled"> {item.name}</span>
                </li>
              ))}
            </ul>
          </div>
          <div id="" className="col-lg-7 col-md-6 col-sm-7 text-right mt-3 fs-sm-10">
            <div className="inlineblock text-center">
              <div className="">
                <Flex gap={isMobile ? 1 : 12} align="center">
                  {customDate ? (
                    <b className="fs-14 fs-sm-10" style={{ marginRight: "5px" }}>
                      <CalendarOutlined /> {time} ,{" "}
                      {moment().locale(dFormat).format("ll")}
                    </b>
                  ) : null}

                  <Button
                    shape="circle"
                    title="Reload"
                    size={isMobile ? "small" : "middle"}
                    type="primary"
                    className={isMobile ? "fs-11" : ""}
                    // style={{ background: customDate ? "#f4f7f6" : "#fff" }}
                    onClick={() => handleReload(activeKey1)}
                    children={!reloading ? <ReloadOutlined /> : <LoadingOutlined />}
                    disabled={reloading}
                  />

                </Flex>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PageHeader;
